import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);


  const state = {
    current_agency_id: ""
  }
  const getters = {
    currentAgencyId: (state)=> {
      return state.current_agency_id;
      }
      
  }
  const actions = {
    changeAgency({ commit }, data) {
      commit("updateAgency", data);
    }
  }
  const mutations = {
      updateAgency(state, data) {
          console.log(data)
      state.current_agency_id = data;
    }
  }
export default {
  state,
  actions,
  getters,
  mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/CSMModule.js